import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import FatReducedMilkProduct from 'models/FatReducedMilkProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import {
  fatReducedMilkTypeOptions,
  containerSizeOptionsDefault,
  fatContainerSizeOptions,
  lactoseContainerSizeOptions,
  powderedContainerSizeOptions,
  evaporatedContainerSizeOptions,
  packagingInitialState,
} from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'

const FatReducedMilkPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  // eslint-disable-next-line no-unused-vars
  const [packaging, setPackaging] = useState(packagingInitialState)

  const [containerSizeOptions, setContainerSizeOptions] = useState(
    containerSizeOptionsDefault
  )

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { setSelect, asterisk } = useFormUtils()

  const methods = useFormContext()

  const setContainerSize = () => {
    if (
      ['Nonfat', '1% Lowfat', '2% Reduced Fat'].includes(
        current.ReducedFatMilkType
      )
    ) {
      setContainerSizeOptions(fatContainerSizeOptions)
    } else if (
      ['Nonfat Lactose Free', 'Lowfat Lactose Free'].includes(
        current.ReducedFatMilkType
      )
    ) {
      setContainerSizeOptions(lactoseContainerSizeOptions)
    } else if (current.ReducedFatMilkType === 'Nonfat Powdered Dry') {
      setContainerSizeOptions(powderedContainerSizeOptions)
    } else if (current.ReducedFatMilkType === 'Nonfat Evaporated') {
      setContainerSizeOptions(evaporatedContainerSizeOptions)
    }
  }

  const containerSizeReset = () => {
    methods.reset(
      { ReducedFatMilkSize: '' },
      {
        errors: false, // errors will not be reset
        dirtyFields: false, // dirtyFields will not be reset
        dirty: false, // dirty will not be reset
        isSubmitted: false,
        touched: false,
        isValid: false,
        submitCount: false,
      }
    )
  }

  useEffect(() => {
    setScrollToTop(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (current?.category === packagingInitialState.category) {
      const {
        category,
        subCategory,
        ReducedFatMilkType,
        ReducedFatMilkSize,
      } = current
      setPackaging({
        category,
        subCategory,
        ReducedFatMilkType: {
          value: ReducedFatMilkType || '',
          label:
            ReducedFatMilkType.length > 0 ? ReducedFatMilkType : 'Milk Type',
        },
        ReducedFatMilkSize: {
          value: ReducedFatMilkSize || '',
          label:
            ReducedFatMilkSize.length > 0
              ? ReducedFatMilkSize
              : 'Container Size',
        },
      })
      setContainerSize()
    } else if (!updating) {
      setCurrent(FatReducedMilkProduct)
    }
    // eslint-disable-next-line
    }, [current])

  useEffect(() => {
    if (current?.fkCategory === packagingInitialState.category) {
      setContainerSize()
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Milk Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={fatReducedMilkTypeOptions}
          name="ReducedFatMilkType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Milk Type'}
          onChange={([selected]) => {
            containerSizeReset()
            setSelect(selected, 'ReducedFatMilkType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="ReducedFatMilkType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <p>
          <strong>
            Size {current?.ReducedFatMilkType !== '' ? asterisk : null}
          </strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={containerSizeOptions}
          name="ReducedFatMilkSize"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Size'}
          onChange={([selected]) => {
            setSelect(selected, 'ReducedFatMilkSize')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="ReducedFatMilkSize"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
      </Col>
    </Row>
  )
}

export default FatReducedMilkPackage
